// eslint-disable-next-line import/prefer-default-export
export const MOMENT_STATE_TO_IMAGE = {
  rejected: 'checkin_rejected.svg',
  draft_scheduled: 'checkin_scheduled_pending.svg',
  draft: 'checkin_pending.svg',
  scheduled: 'checkin_scheduled_approved.svg',
  published: 'checkin_approved.svg'
}
